<template>
  <div class="recordItem">
    <div class="titleArea">
      <div v-if="isShowTag" :class="['tag', data.userTaskStatus]">
        {{ statusMap.tagText }}
      </div>
      <div class="title">{{ data.taskName }}</div>
    </div>
    <div class="time">{{ timeStr }}</div>
    <InviteProgress
      v-if="isShowProgress"
      class="progress"
      :autoAlign="false"
      :total="data.total"
      :current="data.current"
      :emptyAvatarImage="emptyAvatarImage"
      :defaultAvatarImage="defaultAvatarImage"
    />
    <div :class="['valueBlock', { greyFont: statusMap.valueFontGrey }]">
      <div class="amount">&yen;{{ data.rewardAmount | centToYuan }}</div>
      <div class="name">优惠券包</div>
      <div
        v-if="statusMap.btnType === 'awardDetail'"
        class="detailBtn"
        @click="handleGoMyAwards"
      >
        查看奖品
      </div>
      <div
        v-if="statusMap.btnType === 'goActHome'"
        class="detailBtn"
        @click="handleGoActHome"
      >
        查看活动
      </div>
      <div v-if="statusMap.btnType === 'delay'" class="detailBtn grey">
        派发中
      </div>
      <div v-if="statusMap.btnType === 'fail'" class="detailBtn grey">
        派发失败
      </div>
    </div>
  </div>
</template>
<script>
import InviteProgress from '../InviteProgress';
import { centToYuan } from '@/components/templates/helper';

export default {
  components: { InviteProgress },
  data() {
    return {
      emptyAvatarImage:
        'https://ops-img-static.huolala.cn/imgs/2021/16244297274037321831462.png'
    };
  },
  filters: { centToYuan },
  props: {
    isShowTag: {
      type: Boolean,
      default: false
    },
    timeStr: {
      type: String
    },
    data: {
      type: Object
    },
    isShowProgress: {
      type: Boolean,
      default: false
    },
    defaultAvatarImage: String
  },
  computed: {
    statusMap() {
      if (this.data.userTaskStatus === 'fail') {
        return {
          tagText: '助力失败',
          btnType: 'none',
          valueFontGrey: true
        };
      }
      if (this.data.userTaskStatus === 'progressing') {
        return {
          tagText: '进行中',
          btnType: 'goActHome'
        };
      }
      // 任务完成且奖励派发成功
      if (
        this.data.userTaskStatus === 'success' &&
        this.data.rewardStatus === 'success'
      ) {
        return {
          tagText: '助力成功',
          btnType: 'awardDetail'
        };
      }
      // 任务完成且奖励派发中
      if (
        this.data.userTaskStatus === 'success' &&
        this.data.rewardStatus === 'DistributeRewardDelay'
      ) {
        return {
          tagText: '助力成功',
          btnType: 'delay'
        };
      }
      // 任务完成且奖励派发失败
      if (
        this.data.userTaskStatus === 'success' &&
        (this.data.rewardStatus === 'DistributeRewardFail' ||
          this.data.rewardStatus === 'TaskRiskFail')
      ) {
        return {
          tagText: '助力成功',
          btnType: 'fail'
        };
      }
      return {};
    }
  },
  methods: {
    handleGoMyAwards() {
      this.$router.push('/my_awards');
      this.$emit('clickGoAwards');
    },
    handleGoActHome() {
      this.$router.push('/');
      this.$emit('clickGoActHome');
    }
  }
};
</script>

<style lang="less" scoped>
.recordItem {
  position: relative;
  margin-bottom: 38px;
  width: 702px;
  height: 214px;
  box-sizing: border-box;
  padding: 20px 30px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);
  line-height: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .time {
    margin-top: 16px;
    font-size: 26px;
    color: #8c8c8c;
  }

  .titleArea {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: normal;

    .tag {
      margin-right: 10px;
      padding: 0 10px;
      border-radius: 7px;
      font-size: 24px;

      &.success {
        color: #ff0044;
        border: 2px solid #ff0044;
      }

      &.progressing {
        color: #ff6600;
        border: 2px solid #ff6600;
      }

      &.fail {
        color: #8c8c8c;
        border: 2px solid #8c8c8c;
      }
    }

    .title {
      font-size: 32px;
      color: #262626;
    }
  }

  .valueBlock {
    position: absolute;
    right: 0;
    top: -10px;
    width: 235px;
    height: 236px;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1;
    color: #ff0044;

    &.greyFont {
      color: #8c8c8c;
    }

    .amount {
      font-size: 60px;
      font-family: 'Alibaba Zhixing';
    }

    .name {
      margin-top: 8px;
      font-size: 26px;
    }

    .detailBtn {
      margin-top: 14px;
      width: 160px;
      height: 48px;
      background: #ff0044;
      border-radius: 24px;
      font-size: 26px;
      color: #ffffff;
      .fc;

      &.grey {
        background: #bfbfbf;
      }
    }
  }

  .progress {
    margin-left: -30px;
    max-width: 447px;
  }
}
</style>
